/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Proyek_OkInputs */

const en_tut_proyek_ok = /** @type {(inputs: Tut_Proyek_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The project page shows its own issues with a kanban board, and your filters come back exactly as you left them.`)
};

const id_tut_proyek_ok = /** @type {(inputs: Tut_Proyek_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halaman proyek menampilkan issue-nya sendiri lengkap dengan papan kanban, dan filter Anda kembali seperti terakhir ditinggalkan.`)
};

/**
* | output |
* | --- |
* | "The project page shows its own issues with a kanban board, and your filters come back exactly as you left them." |
*
* @param {Tut_Proyek_OkInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_proyek_ok = /** @type {((inputs?: Tut_Proyek_OkInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Proyek_OkInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_proyek_ok(inputs)
	return en_tut_proyek_ok(inputs)
});